<template>
  <div class="headerContainer">
    <router-link tag="div" class="logo" to="/home/activitySelect">
      <img src="~@/assets/images/logo.png" />
      <img src="~@/assets/images/logo-line.png" />
    </router-link>
    <div class="title">
      <p>展览参观预约系统</p>
      <p>RESERVATION SYSTEM</p>
    </div>
    <currentUser v-if="$store.state.accountInfo.fullName"></currentUser>
  </div>
</template>
<script>
import currentUser from './currentUser'
import { getToken } from '@/libs/cookieUtil'

export default {
  components: {
    currentUser: currentUser,

  },
  data () {
    return {
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
    }
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.headerContainer {
  height: 9vh;
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  background-image: url("~@/assets/images/headerbg.jpg");
  .showNotice {
    color: white;
    background-color: #ae0c2a;
    color: white;
    padding: 8px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 5px;
    position: absolute;
    right: 2%;
    letter-spacing: 1px;
    font-size: 14px;
    cursor: pointer;
  }
  .logo {
    position: absolute;
    left: 2%;
    display: flex;
    flex-direction: column;
    img {
      width: 260px;
    }
    img:last-child {
      margin-top: 1.5vh;
    }
  }
  .title {
    text-align: center;
    color: white;
    p:first-child {
      font-size: 25px;
      letter-spacing: 5px;
      font-weight: bolder;
    }
    p:last-child {
      font-size: 12px;
      color: #7b7b7b;
      letter-spacing: 2px;
      margin-top: 0.5vh;
    }
  }
  .user {
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: white;
    position: absolute;
    right: 3%;
    top: 34%;
    min-width: 6%;
    p {
      font-size: 12px;
    }
  }
}
@media screen and(max-width: 768px) {
  .headerContainer {
    height: 3.5rem;
    position: relative;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    .title {
      text-align: center;
      color: #e3cfa8;
      p:first-child {
        font-family: cursive;
        font-size: 1.3rem;
      }
      p:last-child {
        font-size: 0.5rem;
      }
    }
    .cloud {
      width: 40px;
      position: absolute;
      left: 0;
      top: 1rem;
    }
    .cloud1 {
      width: 40px;
      position: absolute;
      right: 0;
      top: 1rem;
    }
    .user {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tab/header.vue